import { render, staticRenderFns } from "./SawPage.vue?vue&type=template&id=67b71e14"
import script from "./SawPage.vue?vue&type=script&lang=js"
export * from "./SawPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports